import { call, put } from 'redux-saga/effects';
import { USER_NOTIFICATIONS_GET, NOTIFICATION_DELETE } from '../actions/types';
import { apiUserNotifications } from '../api/user';
import { apiNotificationDelete } from '../api/notifications';
import { createQadraSaga } from './shared';

function* notificationDelete({ payload: { userId, notificationId } }) {
  yield call(apiNotificationDelete, notificationId);
  const { notifications } = yield call(apiUserNotifications, userId);
  yield put({
    type: USER_NOTIFICATIONS_GET._SUCCESS,
    payload: { notifications },
  });
}

const watchNotificationDelete = createQadraSaga(notificationDelete, {
  action: NOTIFICATION_DELETE._REQUEST,
});

export default [watchNotificationDelete];
